import merge from 'lodash/merge'
import {BRANDS} from 'const'
import onelogTheme from '../../shared/themes/onelog'
import {getFooterLogosByBrandList} from '../commonHelper'
import {getLang} from '../../../utils/stringUtils'
import config from '../../../config'

const otherBrandsLogos = getFooterLogosByBrandList([BRANDS.srg, BRANDS.blick, BRANDS.twentymin, BRANDS.tagesanzeiger])
const defaultTheme = {...onelogTheme, otherBrandsLogos: []}
const lang = getLang(window.location.search) || 'de'
const authorizeRedirectURL = `${config.loginUrl}/?lang=${lang}`

export default merge({}, defaultTheme, {
  brand: {
    name: BRANDS.srg,
    authorizeRedirectURL,
  },
  config: {
    thirdParty: true,
  },
  consent: {
    agreements: {
      fontSize: '12px',
    },
  },
  otherBrandsLogos,
})
